import React from 'react'

const NotFound = () => {
    return (
        <div className='h-screen flex flex-col items-center justify-center w-full p-10  dark:bg-black dark:text-white'>
            <h1 className='text-5xl'>PAGE NOT FOUND</h1> </div>
    )
}

export default NotFound;